<div class="message group relative" [ngClass]="message().role">
  <div
    class="avatar w-8 h-8 rounded-full flex-shrink-0"
    [ngClass]="message().role"
  >
    @if (message().role === MessageRole.ASSISTANT) {
      <img
        src="assets/copilot/brightside_bug.png"
        [alt]="copilotName()"
        class="w-full h-full rounded-full object-cover"
      />
    } @else {
      <div
        class="w-full h-full rounded-full bg-primary text-white flex items-center justify-center font-bold text-sm"
      >
        {{ userInitials() }}
      </div>
    }
  </div>

  <div class="message__wrapper">
    @if (message().role === MessageRole.ASSISTANT) {
      <div class="absolute top-0 right-0 pointer-events-none">
        <button
          pButton
          type="button"
          icon="pi pi-copy"
          class="p-button-sm p-button-text opacity-0 group-hover:opacity-100 transition-opacity pointer-events-auto"
          (click)="copyToClipboard(message().content)"
          pTooltip="Copy response"
          tooltipPosition="left"
        ></button>
      </div>
    }

    <div class="meta text-xs text-surface-500 mb-1 flex gap-2">
      <span class="role font-semibold capitalize">
        {{ message().role === MessageRole.ASSISTANT ? copilotName() : userDisplayName() }}
      </span>
      <span class="timestamp">{{ message().created_at | date: 'medium' }}</span>
    </div>

    <div class="content markdown-body">
      <markdown [data]="message().content"></markdown>
    </div>

    @if (message().role === MessageRole.ASSISTANT && showThinkingBelow()) {
      <div class="italic text-surface-600 thinking-dots content mt-1">
        {{ copilotName() }} is thinking<span class="dot">.</span><span class="dot">.</span><span
          class="dot"
          >.</span
        >
      </div>
    }
  </div>
</div>
